import { createStyles, Grid, TextField, Theme, withStyles, WithStyles, Collapse, Typography } from '@material-ui/core'
import React from 'react'
import OutcomeDropDownItem from '../../../FormTemplates/CustomOutcomeDropDown/OutcomeDropDownItem'
import OutcomeDateItem from '../../../FormTemplates/CustomOutcomeDate/OutcomeDateItem'
import moment from 'moment'
import { ConnectedProps, connect } from 'react-redux'
import {updateDateCredentailAttained, genericAction} from '../../../../features/pacticipantOutcomeSlice'
import  FileUploadForm  from '../../../FileUploadForm/FileUpload'
import CustomRadioItem from 'src/components/Templates/CustomRadioItem/CustomRadioItem'


// let CREDENTIAL_TYPES = [
//   'No recognized credential',
//   'Secondary school diploma or equivalency',
//   'AA or AS diploma/degree',
//   'BA or BS diploma/degree',
//   'Occupational licensure',
//   'Occupational certificate',
//   'Occupational certification',
//   'Other recognized diploma, degree, or certificate'
// ]




const mapStateToProps = (state:any) => {
  return{
    dateCredentialAttained1: state.participantOutcome.dateCredentialAttained1,
    dateCredentialAttained2: state.participantOutcome.dateCredentialAttained2,
    credentialType: state.participantOutcome.credentialType,
    credentialType2: state.participantOutcome.credentialType2,
    credential1: state.participantOutcome.credential1,
    credential2: state.participantOutcome.credential2,
    credentialLink1 : state.participantOutcome.credentialLink1,
    credentialLink2 : state.participantOutcome.credentialLink2,
    credentialDoc1Uploaded: state.participantOutcome.credentialDoc1Uploaded,
    credentialDoc2Uploaded: state.participantOutcome.credentialDoc2Uploaded,
  }
};

const mapDispatchToProps = { updateDateCredentailAttained, genericAction };

const connector = connect(
  mapStateToProps,
  mapDispatchToProps
)

type PropsFromRedux = ConnectedProps<typeof connector>


interface CredentialsSectionProps extends WithStyles<typeof styles>, PropsFromRedux{
  index: number
  credentialTypeRequired?:boolean
}

const CredentialsSection: React.FC<CredentialsSectionProps> = (props: CredentialsSectionProps) => {
  const {
    index,
    credentialType,
    credentialType2,
    classes
  } = props

  const [collapseCredentials, setCollapseCredentials] = React.useState(true);
  const [credentialOptionValue,setcredentialOptionValue] = React.useState('upload')
  const [link,setLink] = React.useState('')
  const [CREDENTIAL_TYPES,set_CREDENTIAL_TYPES] = React.useState([
    'No recognized credential',
    'Secondary school diploma or equivalency',
    'AA or AS diploma/degree',
    'BA or BS diploma/degree',
    'Occupational licensure',
    'Occupational certificate',
    'Occupational certification',
    'Other recognized diploma, degree, or certificate'
  ])

  const handleDateCredentialAttained = (dateCredentialAttained)=>{
    const payload = {
      [`dateCredentialAttained${index}`]: dateCredentialAttained
    }
    props.genericAction(payload)
  }

  const onCredentialTypeChange = (e)=>{
    const credentialType = e.target.value
    const payload = {
      [`credentialType${index>1?index:''}`]: credentialType
    }
    if(e.target.value === "No recognized credential"){
      payload[`credential${index}`] = null
      payload[`dateCredentialAttained${index}`] = null
      setLink('')
      setcredentialOptionValue('')
    }
    props.genericAction(payload)
  }

  const onCredentialChange = (e) =>{
    const payload = {
      [`credential${index}`]: e.target.value
    }
    props.genericAction(payload)
  }

  const onCredentialOptionChange = (e) =>{
    const {value} = e.target
    setcredentialOptionValue(value)
    if(value === 'link'){
      props.genericAction({
        [`credentialDoc${props.index}`]:null,
        [`credentialDoc${props.index}FileName`]:null,
        [`credentialDoc${props.index}FileExt`]:null
      })
    }
    else{
      setLink('')
      props.genericAction({
        [`credentialLink${props.index}`]: ''
      })
    }
  }

  const onCredentialLinkChange = (e) =>{
    const {value} = e.target
    setLink(value)
    props.genericAction({
      [`credentialLink${props.index}`]: value
    })
  }

  React.useEffect(()=>{
    const cred = props[`credentialType${props.index>1?index:''}`]
    if(cred && !CREDENTIAL_TYPES.includes(cred)){
      set_CREDENTIAL_TYPES([...CREDENTIAL_TYPES,cred])
    }
  },[credentialType,credentialType2])


  React.useEffect(() => {
    setCollapseCredentials(props[`credentialType${props.index>1?index:''}`] && !["NO RECOGNIZED CREDENTIAL","UNKNOWN"].includes(props[`credentialType${props.index>1?index:''}`].toUpperCase()))
  }, [credentialType, credentialType2]);

  const radioOptions = [
    {value:'upload',label:'Upload actual document or image'},
    {value:'link',label:'Web link (e.g., state licensure records)'}]

  
  const getDateValue = ()=>{
      if(!props[`dateCredentialAttained${index}`]){
        return ''
      }
      else{
        const value =  moment(moment(props[`dateCredentialAttained${index}`]).format("YYYY-MM-DD")).toDate()
        return value
      }
    }

  return (
    <Grid className={classes.container}>
      <OutcomeDropDownItem
        label={`Type of Credential ${index}`}
        prop="credentialType"
        value={props[`credentialType${props.index>1?props.index:''}`]}
        onInputChange={onCredentialTypeChange}
        items={CREDENTIAL_TYPES}
        required={(props.credentialTypeRequired === false)? false: true}
        hideUnknown={true}
      />
      <Collapse
        in={collapseCredentials}
        style={{ transformOrigin: '0 0 0', flexGrow: 1 }} {...(collapseCredentials ? { timeout: 750 } : {})}>
          <Grid container={true} className={classes.alignCenter}>
            <Grid item={true} className={classes.label}>
              {`Credential ${index} Name`}&#58; { collapseCredentials === true && (<span className={classes.requiredField} >*</span> ) }
            </Grid>
            <Grid item={true} className={classes.textbox}>
              <TextField
                  name={`credential${index}`}
                  className={classes.dropdown}
                  value={props[`credential${index}`]?props[`credential${index}`]:''}
                  onChange={onCredentialChange}
                  margin="dense"
                  variant="outlined"
                  required={collapseCredentials}
                />
            </Grid>
          </Grid>
          
        <OutcomeDateItem
            label={`Date credential ${index} was obtained or issued`}
            prop="dateCredentialAttained"
            value={getDateValue}
            onDateChange={({target})=>{handleDateCredentialAttained(target.value)}}
            minDate={
              moment().subtract(100, 'years').format('YYYY-MM-DD')
            }
            maxDate={
              moment().format('YYYY-MM-DD')
            }
            required={collapseCredentials}
            />


            {/* Note for file uploaded */}
            {/* {((props[`credentialDoc${props.index}Uploaded`]) && (<Typography 
                                                                    variant="h6" 
                                                                    component="h6" 
                                                                    className={classes.info}>
                                                                      {`Note: Credential ${index} was uploaded previously`}
                                                                    </Typography>))} */}

            {/* <CustomRadioItem propName='credential-option' 
              radioOptions={radioOptions} 
              onRadioChange={onCredentialOptionChange} 
              title='How can this credential be verified?' 
              value={credentialOptionValue}  /> */}

            {/* File Upload button */}
             {(credentialOptionValue === 'upload') && <FileUploadForm index={index}/>}
            
             {(credentialOptionValue === 'link') && <Grid container={true} className={classes.alignCenter}>
                <Grid item={true} className={classes.label}>
                  {`Credential ${index} Web Link`}&#58;
                </Grid>
                <Grid item={true} className={classes.textbox}>
                  <TextField
                        name={`credentialLink${index}`}
                        className={classes.dropdown}
                        value={link}
                        onChange={onCredentialLinkChange}
                        margin="dense"
                        variant="outlined"
                    />
                </Grid>
              </Grid>
             }
      </Collapse>
    </Grid>
  )
}


const styles = (theme: Theme) =>
	createStyles({
		dropdownLabel: {
			display: 'flex',
			justifyContent: 'flex-end',
			alignItems: 'center',
			paddingTop: '12px',
			[theme.breakpoints.down('sm')]: {
				justifyContent: 'flex-start',
			},
		},
		dropdown: {
			display: 'flex',
			flex: 1,
		},
    container:{
      display: 'block'
    },
    alignCenter:{
      alignItems:'center'
    },
    label:{
      justifyContent: 'flex-end',
      flexGrow:0,
      flexBasis: '25%',
      display:'flex',
      paddingRight: '8px'
    },
    textbox:{
      justifyContent: 'flex-start',
      flexGrow:0,
      flexBasis: '75%',
      display:'flex'
    },
    warn:{
      color: 'orange',
      fontSize: '1rem'
    },
    info:{
      color: '#3743d4',
      fontSize: '1rem'
    },
    requiredField:{
      color:'red'
    }
	})

export default connector(withStyles(styles)(CredentialsSection))
